import './Guide.css';
import { useNavigate } from "react-router-dom"
import { useTranslation } from 'react-i18next';
import TopBar from "../../common/TopBar";

export default function Guide() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const topHeader = {
    title: t('guidePage.title'),
    leftIcon: "/images/totp/ui/left.png",
  }
  const handleGoToList = () => {
    navigate("/vtotp/otp-list");
  }

  return(
    <div className="page-wrapper">
      <TopBar topHeader={topHeader} onLeftClick={handleGoToList}/>
      <div className="page-content">
      <div className="guide-container">

        {/* Usability Section */}
        <section className="guide-section">
          <div className="guide-header">
            <div className="guide-icon">
              <img src={`${process.env.PUBLIC_URL}/images/totp/ui/think.png`} alt="Usability" />
            </div>
            <h2>{t('guidePage.usabilityTitle')}</h2>
          </div>
          <div className="guide-content">
            <p>{t('guidePage.usabilityText1')}</p>
            <p>{t('guidePage.usabilityText2')}</p>
            <p>{t('guidePage.usabilityText3')}</p>
            <p>{t('guidePage.usabilityText4')}</p>
          </div>
        </section>

        {/* Caution Section */}
        <section className="guide-section">
          <div className="guide-header">
            <div className="guide-icon">
              <img src={`${process.env.PUBLIC_URL}/images/totp/ui/warning.png`} alt="Caution" />
            </div>
            <h2>{t('guidePage.cautionTitle')}</h2>
          </div>
          <div className="guide-content">
            <p>{t('guidePage.cautionText1')}</p>
            <p>{t('guidePage.cautionText2')}</p>
            <p>{t('guidePage.cautionText3')}</p>
          </div>
        </section>

        {/* Camera Section */}
        <section className="guide-section">
          <div className="guide-header">
            <div className="guide-icon">
              <img src={`${process.env.PUBLIC_URL}/images/totp/ui/camera.png`} alt="Camera" />
            </div>
            <h2>{t('guidePage.cameraTitle')}</h2>
          </div>
          <div className="guide-content">
            <p>{t('guidePage.cameraText1')}</p>
            <p>{t('guidePage.cameraText2')}</p>
          </div>
        </section>


        {/* OTP Code Section */}
        <section className="guide-section">
          <div className="guide-header">
            <div className="guide-icon">
              <img src={`${process.env.PUBLIC_URL}/images/totp/ui/otpcode.png`} alt="Camera" />
            </div>
            <h2>{t('guidePage.otpCodeTitle')}</h2>
          </div>
          <div className="guide-content">
            <p>{t('guidePage.otpCodeText1')}</p>
            <p>{t('guidePage.otpCodeText2')}</p>

          </div>
        </section>


        {/* Security Section */}
        <section className="guide-section">
          <div className="guide-header">
            <div className="guide-icon">
              <img src={`${process.env.PUBLIC_URL}/images/totp/ui/cyber-security.png`} alt="Security" />
            </div>
            <h2>{t('guidePage.securityTitle')}</h2>
          </div>
          <div className="guide-content">
            <h4>{t('guidePage.androidTitle')}</h4>
            <p>{t('guidePage.androidText1')}</p>
            <p>{t('guidePage.androidText2')}</p>
            <p>{t('guidePage.androidText3')}</p>
            <p>{t('guidePage.androidText4')}</p>
            <p>{t('guidePage.androidText5')}</p>
            <h4>{t('guidePage.iphoneTitle')}</h4>
            <p>{t('guidePage.iphoneText1')}</p>
            <p>{t('guidePage.iphoneText2')}</p>
            <p>{t('guidePage.iphoneText3')}</p>
            <p>{t('guidePage.iphoneText4')}</p>
            <p>{t('guidePage.iphoneText5')}</p>
          </div>
        </section>

        <div className="guide-footer"></div>
      </div>
      </div>
    </div>
  )
}
